import "./enregistre.css";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../components/commons/CustomBtn";
import FavorisListe from "./components/FavorisListe";
import {
  removeEnregistresOpenLot,
  setEnregistresActiveOnglet,
} from "../../redux/actions/enregistresActions";
import Programmes from "../immobilier/views/programmes/Programmes";
import Lot from "../immobilier/views/lot/Lot";
import { useEffect, useState } from "react";
import SavedSearches from "./components/savedSearches";
import { UserData } from "../../redux/actions/userAuthActions";

const Enregistre = () => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.userAuthReducer);
  const {
    openLots,
    openLotsData,
    openLotsLoading,
    activeOnglet,
    singleProgramId,
  } = useSelector((state) => state.enregistresReducer);

  useEffect(() => {
    dispatch(UserData());
  }, [dispatch]);
  const handleCloseLot = (documentId) => {
    if (activeOnglet === `lot-${documentId}`) {
      dispatch(setEnregistresActiveOnglet("favoris"));
    }
    dispatch(removeEnregistresOpenLot(documentId));
  };

  const onlgetSetter = (onglet) => {
    dispatch(setEnregistresActiveOnglet(onglet));
  };
  const [displayedLot, setDisplayedLot] = useState(null);
  return (
    <div className="enregistre-container">
      <div className="d-flex gap10">
        <CustomButton
          onClick={() => onlgetSetter("favoris")}
          label="Favoris"
          subtitle={`${user?.lots_favoris.length || 0} Lot | ${user?.programmes_favoris.length || 0
            } Programme`}
          contentLengthClass={`${activeOnglet === "favoris"
            ? "regular fs11 pink "
            : "regular fs11 white"
            } `}
          buttonClass={`${activeOnglet === "favoris"
            ? "bg-white radiusTop5 px-20 py-10"
            : "bg-pink radiusTop5 px-20 py-10 white"
            } `}
          labelClass={`${activeOnglet === "favoris"
            ? "pink fs16 semibold text-capitalize text-start"
            : "white fs16 semibold text-capitalize text-start"
            }`}
        />
        <CustomButton
          onClick={() => onlgetSetter("savedSearches")}
          label="Mes recherches enregistrées "
          subtitle={
            user?.search_histories?.length > 100
              ? "+100"
              : user?.search_histories?.length
          }
          contentLengthClass={`${activeOnglet === "savedSearches"
            ? "regular fs11 pink "
            : "regular fs11 white"
            } `}
          buttonClass={`${activeOnglet === "savedSearches"
            ? "bg-white radiusTop5 px-20 py-10"
            : "bg-pink radiusTop5 px-20 py-10 white"
            } `}
          labelClass={`${activeOnglet === "savedSearches"
            ? "pink fs16 semibold text-capitalize text-start"
            : "white fs16 semibold text-capitalize text-start"
            }`}
        />

        {singleProgramId && (
          <CustomButton
            onClick={() => onlgetSetter("programme")}
            label="Programme"
            buttonClass={`${activeOnglet === "programme"
              ? "bg-white radiusTop5 px-20 py-10 pink"
              : "bg-pink radiusTop5 px-20 py-10 white"
              } `}
            labelClass=" fs16 semibold text-capitalize text-start"
          />
        )}
        {openLots.map((lotId) => (
          <div
            key={lotId}
            className="d-flex align-items-center position-relative"
          >
            <CustomButton
              onClick={() => onlgetSetter(`lot-${lotId}`)}
              label={
                openLotsLoading[lotId] ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : openLotsData[lotId]?.reference ? (
                  `Lot ${openLotsData[lotId]?.reference}`
                ) : (
                  "Lot"
                )
              }
              buttonClass={`${activeOnglet === `lot-${lotId}`
                ? "bg-white radiusTop5 px-20 py-10 pink  h-100"
                : "bg-pink radiusTop5 px-20 py-10 white  h-100"
                } `}
              labelClass="fs16 semibold text-capitalize text-start"
            />
            <button
              onClick={() => handleCloseLot(lotId)}
              className="close-button"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      <div className="content-container">
        {activeOnglet === "favoris" && <FavorisListe user={user} />}
        {activeOnglet === "savedSearches" && (
          <SavedSearches savedSearches={user?.search_histories} />
        )}
        {activeOnglet === "programme" && (
          <Programmes
            programmeId={singleProgramId}
            setDisplayedLot={setDisplayedLot}
            displayedLot={displayedLot}
          />
        )}
        {openLots.map(
          (lotId) =>
            activeOnglet === `lot-${lotId}` && (
              <div key={lotId} className="lot-container">
                {openLotsLoading[lotId] ? (
                  <div className="d-flex justify-content-center align-items-center p-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <Lot
                    lotId={lotId}
                    lotData={openLotsData[lotId]}
                    isEnregistres={true}
                  />
                )}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default Enregistre;
